module.exports = __webpack_public_path__ + "img/en-uk.ce5a2bd9.png";